export enum HistoryTransactionDetailsColumn {
    LOG_TIME = "logTime",
    DATE = "date",
    DESCRIPTION = "description",
    OLD_VALUE = "oldValue",
    NEW_VALUE = "newValue",
    FINANCIAL_ACCOUNT = "financialAccount",
    AMOUNT = "amount",
    ENTITY = "entity",
    ACTIONS = "actions",
}
